import notfound_img from "../../assets/404notfound.png";

export const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <h1>La page que vous cherchez n'existe pas !</h1>
      <img
        src={notfound_img}
        alt="Image of Page Not Found"
        className="w-56 h-fit"
      />
    </div>
  );
};
